import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'

export const $ModalContainer = styled.div`
  min-width: 500px;
`

export const $SelectModalContainer = styled.div`
  min-width: 300px;
  padding-top: ${({ theme }) => theme.spacing(2)};
`

export const $ElementsContainer = styled.div`
  max-height: 100px;
  overflow-y: auto;
  border: 1px solid ${({ theme }) => theme.colors.input?.border || '#ccc'};
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.colors.cards?.background || '#fafafa'};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`

export const $ElementItem = styled.div`
  cursor: pointer;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(0.5)}`};
  border-radius: 4px;
  flex: 1;
  &:hover {
    background-color: ${({ theme }) => theme.colors.cards?.backgroundDark || '#f0f0f0'};
  }
`

export const $ElementRow = styled(Grid)`
  padding: ${({ theme }) => `${theme.spacing(0.25)} 0`};
`

export const $ActionsContainer = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const $ButtonContainer = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(3)};
`

export const $ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.error || 'red'};
  font-size: 0.85em;
  margin: ${({ theme }) => theme.spacing(0.5)} 0 0;
`

export const $HelperText = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 0.85em;
  margin: ${({ theme }) => `0 0 ${theme.spacing(1)}`};
`

export const $SectionLabel = styled.div`
  width: fit-content;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => `${theme.spacing(0.25)} ${theme.spacing(1.5)}`};
  font-size: 1.1em;
  margin: ${({ theme }) => `${theme.spacing(2)} 0 ${theme.spacing(1)}`};
`

export const $FieldsGrid = styled(Grid)`
  margin-top: ${({ theme }) => theme.spacing(1)};
`

export const $Summary = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  line-height: 28px;
  padding: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.colors.cards.background};
  border-radius: 4px;
`

export const $TitleSpan = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
`

export const $ElementSpan = styled.span`
  font-weight: bold;
  padding: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.cards.backgroundDark};
`

export const $TabPanel = styled.div`
  padding: ${({ theme }) => theme.spacing(2)} 0;
`
